import type { SearchClient } from 'algoliasearch/lite';
import { useContext } from 'use-context-selector';
import type { AlgoliaIndex } from 'utils/algoliaConstants';
import { ContentSectionComponent } from '../contentSectionComponent/ContentSectionComponent';
import { PLPContext } from '../plpContext/PLPProvider';
import { PLPProductGrid } from '../plpProductGrid/PLPProductGrid';
import { PLPSections } from '../plpSections/PLPSections';
import { Shelf } from '../shelf/Shelf';

type PLPProviderProps = {
  searchClient: SearchClient;
  hasFiltersApplied: boolean;
  collectionHandle: string;
  keyHandle: string;
  indexName: AlgoliaIndex;
};

export const PLPContent = ({
  searchClient,
  hasFiltersApplied,
  collectionHandle,
  keyHandle,
}: PLPProviderProps) => {
  const plpContext = useContext(PLPContext);

  if (plpContext === undefined)
    throw new Error('PLPContent must be used within a PLPContext');

  const { shelves, shelfSections } = plpContext;

  const showShelves = Boolean(shelves?.length && !hasFiltersApplied);

  return (
    <>
      {showShelves &&
        shelfSections?.map((section, index) => {
          if (section?.__typename === 'Shelf') {
            return (
              <Shelf
                key={`${section.__typename}-${index}`}
                collectionHandle={collectionHandle}
                keyHandle={keyHandle}
                franchiseBlock={section.franchiseBlock}
                filters={section.filters}
                inGridContent={section.inGridContent}
                searchClient={searchClient}
                asIndex={true}
                numberOfRows={section.numberOfRows}
              />
            );
          }

          return (
            <div
              key={`${section?.__typename}-${index}`}
              className="content-section"
            >
              <ContentSectionComponent section={section} asIndex={true} />
            </div>
          );
        })}

      {!showShelves && <PLPProductGrid collectionHandle={collectionHandle} />}

      <div>
        <PLPSections asIndex={true} />
      </div>
    </>
  );
};
